import { memo } from "react";
import MinimapButton from "../../components/MinimapButton";
import ZoomControls from "../../components/ZoomControls";
import { Box } from "@mui/material";
import { Panel } from "reactflow";

const sxStyles = {
    blurrerBox: {
        display: "flex",
        alignItems: "flex-end",
        gap: "8px",
        mb: 2
    }
};

const BottomLeftPanel = memo(() => {
    return (
        <Panel position="bottom-left">
            <Box sx={sxStyles.blurrerBox}>
                <MinimapButton />
                <ZoomControls />
            </Box>
        </Panel>
    );
});

export default BottomLeftPanel;
